import React from "react";
import { FormattedMessage } from "react-intl";
import globalMessages from "../../../intl/globalMessages";
import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Formulaires",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "active",
        widget: "singleSwitch",
        toggleAction: true,
        displayName: "Actif",
      },
      {
        fieldName: "dependers",
        searchCriteria: "type",
        fieldSelector: {
          EXTRA: "Extra",
          GUEST_FORM: "Formulaire client",
          CANCELLATION_FORM: "Popup d'annulation",
          ROOMSTAY_CHECKOUT: "Formulaire de check-out",
        },
        displayName: "Activer pour",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "propertyTicker",
        widget: "hidden",
      },
      {
        fieldName: "active",
        displayName: "Actif",
        widget: "singleSwitch",
        className: "activeCheckbox",
      },
      {
        fieldName: "dependers",
        displayName: "Activer pour :",
        widget: "selector",
        optionDisplay: {
          EXTRA: {
            label: "Extras",
          },
          GUEST_FORM: {
            label: "Formulaire client",
          },
          CANCELLATION_FORM: {
            label: "Modal d'annulation",
          },
          ROOMSTAY_CHECKOUT: {
            label: "Check-out: RoomStay",
          },
        },
        defaultValue: "EXTRA",
      },
      {
        fieldName: "dependersBoxes",
        widget: "multicheckbox",
        selectables: true,
        selectAllText: <FormattedMessage {...globalMessages.selectAll} />,
        selectNoneText: "Désélectionner tout",
        visible: ({ formValues }) => {
          return formValues.dependers === "EXTRA";
        },
      },
      {
        fieldName: "fields",
        displayName: "Questions",
        introductionText: "L'ordre des questions sera reflété dans le formulaire",
        widget: "nestedEntity",
        nestedTitle: "Modifier",
        nested: true,
        entityName: "CancellationPolicyConfiguration",
        defaultValue: [],
      },
    ],
  },
};
